import { PayloadAction } from '@reduxjs/toolkit'
import { reducerCreatorProducer } from 'store/common'
import {
  IEditorState,
  TActiveTimelineItems,
  TClipboardItem,
  TLibraryFonts
} from 'store/types/editor'
import { TOverlayItemType } from 'types'

const reducers = reducerCreatorProducer<IEditorState>()({
  setActiveSidebarTab: (state, action: PayloadAction<string | null>) => {
    state.activeSidebarTab = action.payload
  },
  setAsideOverlayContent: (
    state,
    action: PayloadAction<TOverlayItemType | null>
  ) => {
    state.activeAsideOverlayKey = action.payload
  },
  toggleAsideOverlayContent: (
    state,
    action: PayloadAction<TOverlayItemType>
  ) => {
    state.activeAsideOverlayKey =
      state.activeAsideOverlayKey === action.payload ? null : action.payload
  },
  setActiveTimelineItems: (
    state,
    action: PayloadAction<TActiveTimelineItems>
  ) => {
    state.activeTimelineItems = action.payload
  },
  addActiveTimelineItems: (
    state,
    action: PayloadAction<TActiveTimelineItems>
  ) => {
    state.activeTimelineItems = [
      ...state.activeTimelineItems,
      ...action.payload
    ]
  },
  removeActiveTimelineItems: (state, action: PayloadAction<string[]>) => {
    state.activeTimelineItems = state.activeTimelineItems.filter(
      item => item.id === null || !action.payload.includes(item.id)
    )
  },
  setTimelineRulerSliceDuration: (state, action: PayloadAction<number>) => {
    state.timelineRulerSliceDuration = action.payload
  },
  setIsMobileSubSidebarOpen: (state, action: PayloadAction<boolean>) => {
    state.isMobileSubSidebarOpen = action.payload
  },
  setIsMobileInnerSliderOpen: (state, action: PayloadAction<boolean>) => {
    state.isMobileInnerSliderOpen = action.payload
  },
  setIsTimelineItemDragging: (state, action: PayloadAction<boolean>) => {
    state.isTimelineItemDragging = action.payload
  },
  setIsTimelineItemResizing: (state, action: PayloadAction<boolean>) => {
    state.isTimelineItemResizing = action.payload
  },
  setIsMediaBuffering: (state, action: PayloadAction<boolean>) => {
    state.isBuffering = action.payload
  },
  setApiErrorPopupData: (
    state,
    action: PayloadAction<{ type: string; message?: string }>
  ) => {
    state.apiErrorPopupData = action.payload
  },
  resetApiErrorPopupData: state => {
    state.apiErrorPopupData = {
      type: '',
      message: ''
    }
  },
  setIsWelcomePopupOpen: (state, action: PayloadAction<boolean>) => {
    state.isWelcomePopupOpen = action.payload
  },
  setClipboard: (state, action: PayloadAction<TClipboardItem | null>) => {
    state.clipboard = action.payload
  },
  setLibraryFonts: (state, action: PayloadAction<TLibraryFonts>) => {
    state.libraryFonts = action.payload
  },
  // TODO: remove when canvas text editing is enabled
  bumpTextSidebarPulse: state => {
    state.textSidebarPulseToken += 1
  }
})

export default reducers
